module.exports = __webpack_public_path__ + "img/DonateMoneyBg.5d92066f.png";